/**
 * useTodos — 나의 할일 조회. GET /schedule/todos?scope=today|week
 * 호출자(X-User-Id)가 현장 담당자(CHARGE·MANAGER)인 현장의 오늘 할일(+ week 면 7일 일정)이 서버가 정한 순서로 온다.
 * 항상 최신(staleTime 0 · 마운트·포커스 재조회). 오류는 isError 로 노출 — 빈 결과를 폴백으로 덮지 않는다.
 * 쿼리 키 ['todos', { scope, siteId, owner }] — 신호 변경 시 scheduler 의 useInvalidateSignals 가 접두 ['todos'] 로 무효화한다.
 */
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@indipia/shared';
import type { TodosResponse } from '@indipia/shared';
import { getTodos } from '../api/signals';

export interface UseTodosOptions {
  scope?: 'today' | 'week';
  /** 한 현장만 */
  siteId?: number;
  /** 담당자 지정(생략하면 로그인 사용자) */
  owner?: number;
  enabled?: boolean;
}

export function useTodos({ scope = 'today', siteId, owner, enabled = true }: UseTodosOptions = {}) {
  const user = useAuthStore(s => s.user);
  const headers = {
    ...(user?.compId ? { 'X-Comp-Id': String(user.compId) } : {}),
    ...(user?.memberId ? { 'X-User-Id': String(user.memberId) } : {}),
  };
  return useQuery<TodosResponse>({
    queryKey: ['todos', { scope, siteId, owner }],
    queryFn: () => getTodos({ scope, siteId, memberId: owner }, headers),
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}
